import React, { createContext, Fragment, useEffect } from 'react';
import { Button, Input, Modal } from 'alurkerja-ui';
import { FaPlus } from 'react-icons/fa';
import { ITasklistProcess } from '@/api/tasklist';
import BusinessProcessItem from './BusinessProcessItem';

type ModalNewRequestProps = {
  businessProcesses: ITasklistProcess[];
};

type IModalNewRequestContext = {
  open: boolean;
  closeModal: () => void;
  resetSearch: () => void;
};
export const ModalNewRequestContext = createContext<IModalNewRequestContext>({} as IModalNewRequestContext);

const ModalNewRequest: React.FC<ModalNewRequestProps> = ({ businessProcesses }) => {
  const [filteredBusinessProcesses, setFilteredBusinessProcesses] =
    React.useState<ITasklistProcess[]>(businessProcesses);

  useEffect(() => {
    setFilteredBusinessProcesses(businessProcesses);
  }, [businessProcesses]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value.toLowerCase();
    const filtered = businessProcesses.filter(item => {
      const itemName = item.name?.toLowerCase();
      return itemName?.includes(searchValue) || false;
    });
    setFilteredBusinessProcesses(filtered);
  };

  const resetSearch = () => {
    setFilteredBusinessProcesses(businessProcesses);
  };

  return (
    <Modal
      title={'New Request'}
      maxWidth="4xl"
      triggerButton={
        <Button className="p-2 px-3 items-center text-sm text-white flex flex-row gap-2" color="green">
          <FaPlus size={16} />
          <div> New Request</div>
        </Button>
      }
    >
      {({ closeModal }) => (
        <div className="flex flex-col ">
          <div className="w-full p-4">
            <Input placeholder="Search Business Process..." onChange={handleSearch} name="search" autoFocus />
          </div>
          <div className=" p-4 grid grid-cols-2 sm:grid-cols-3 gap-3">
            {filteredBusinessProcesses.map((process, index) => (
              <Fragment key={index}>
                <ModalNewRequestContext.Provider
                  value={{ open: true, closeModal: closeModal, resetSearch: resetSearch }}
                >
                  <BusinessProcessItem {...process} />
                </ModalNewRequestContext.Provider>
              </Fragment>
            ))}
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ModalNewRequest;
